import { Button, Modal, Text } from "@mantine/core";
import type { DateTime } from "luxon";
import { useState } from "react";
import { ModalFooter } from "../../../mantine/components/ModalFooter/ModalFooter";
import { DateInput } from "../../../mantine/dates/DateInput/DateInput";
import { useToast } from "../../../mantine/notifications/useToast";
import { useMieterstromMBKCreation } from "../EdaVisualization/hooks/useMbks";

type CreateMieterstromMBKModalProps = {
  isOpen: boolean;
  onClose: () => void;
  siteId: number;
  onVersionCreated: () => void;
};

export function CreateMieterstromMBKModal({
  isOpen,
  onClose,
  siteId,
  onVersionCreated
}: CreateMieterstromMBKModalProps) {
  const { showToast, showErrorToast } = useToast();
  const [firstDate, setFirstDate] = useState<DateTime>();

  const handleMBKCreationSuccess = () => {
    showToast({
      type: "success",
      message: "Mess- und Bilanzierungskonzept erfolgreich erstellt."
    });
    onVersionCreated();
    onClose();
  };

  const handleMBKCreationError = (error) => {
    showErrorToast(error);
  };

  const { mutate: createMieterstromMBK, isPending } =
    useMieterstromMBKCreation(siteId);

  const submit = () => {
    if (firstDate) {
      createMieterstromMBK(
        { firstDate },
        { onSuccess: handleMBKCreationSuccess, onError: handleMBKCreationError }
      );
    }
  };

  return (
    <Modal
      opened={isOpen}
      size="lg"
      title={MODAL_HEADER_LABEL}
      onClose={onClose}
    >
      <Text>{DATEPICKER_LABEL}</Text>
      <DateInput
        id={DATEPICKER_LABEL}
        value={firstDate}
        onChange={(e) => setFirstDate(e ?? undefined)}
      />
      <ModalFooter>
        <Button variant="default" onClick={onClose}>
          {CANCEL_BUTTON_LABEL}
        </Button>
        <Button
          color="primary"
          disabled={typeof firstDate === "undefined"}
          loading={isPending}
          onClick={submit}
        >
          {SAVE_BUTTON_LABEL}
        </Button>
      </ModalFooter>
    </Modal>
  );
}

const MODAL_HEADER_LABEL =
  "Ab wann ist das Mess- und Bilanzierungskonzept gültig?";
const DATEPICKER_LABEL =
  "Bitte wählen Sie das gewünschte Startdatum für Ihr Mess- und Bilanzierungskonzept.";
const CANCEL_BUTTON_LABEL = "Abbrechen";
const SAVE_BUTTON_LABEL = "Mess- und Bilanzierungskonzept erstellen";
